import * as flags from "country-flag-icons/react/3x2";
import countries from "i18n-iso-countries";

export const CountryFlag = ({ countryCode, width, height }: { 
    countryCode?: string; 
    width?: number; 
    height?: number 
}) => {
    if (!countryCode) return null;

    const normalizedCode = countryCode.toUpperCase();

    const alpha2 = normalizedCode.length === 3 ? countries.alpha3ToAlpha2(normalizedCode) : normalizedCode;

    if (!alpha2) return null;

    const FlagComponent = (flags as Record<string, React.ComponentType<any>>)[alpha2];

    if (!FlagComponent) return null;

    return <FlagComponent style={{ width: width || 24, height: height || 18 }} />;
};